export interface NewsAlertModel {
  notificationId: string;
  releaseNoteId: string;
  title: string;
  subject: string;
  body: string;
  severity: NewsAlertSeverity;
  startAt: Date;
  endAt: Date;
  latestReleaseUrl?: string;
  sentAt: Date;
}


export interface ClientAlertModel {
  /** Unique notification identifier */
  notificationId: string;
  /** Notification type (default: GeneralClientNotification) */
  type: string;
  /** Client ID this notification is targeted to */
  clientId: string;
  /** Company ID this notification is targeted to */
  companyId: string;
  /** Notification title */
  title: string;
  /** Notification subject */
  subject: string;
  /** Notification message body */
  message: string;
  /** Severity level (Info, Warning, Critical) */
  severity: NewsAlertSeverity;
  /** When the notification was created (UTC) */
  createdAt: string;
  /** When the notification was sent (UTC) */
  sentAt: string;
}

export enum NewsAlertSeverity {
  Info = 'Info',
  Warning = 'Warning',
  Critical = 'Critical'
}

/**
 * Helper function to map severity string to CSS class
 */
export function getSeverityClass(severity: NewsAlertSeverity | string): string {
  switch (severity) {
    case NewsAlertSeverity.Critical:
    case 'Critical':
      return 'alert-danger';
    case NewsAlertSeverity.Warning:
    case 'Warning':
      return 'alert-warning';
    case NewsAlertSeverity.Info:
    case 'Info':
    default:
      return 'alert-info';
  }
}

/**
 * Helper function to get severity icon
 */
export function getSeverityIcon(severity: NewsAlertSeverity | string): string {
  switch (severity) {
    case NewsAlertSeverity.Critical:
    case 'Critical':
      return 'ri-error-warning-fill';
    case NewsAlertSeverity.Warning:
    case 'Warning':
      return 'ri-alert-fill';
    case NewsAlertSeverity.Info:
    case 'Info':
    default:
      return 'ri-information-fill';
  }
}
